var PasswordGenerator = function () {
  this.passwordButtons = $('[data-password-generator]');
};

PasswordGenerator.prototype.attach = function () {
  this.passwordButtons = $('[data-password-generator]');
  this.passwordButtons.on('click', this.generatePassword);
};

PasswordGenerator.prototype.destroy = function () {
  this.passwordButtons.off();
  this.passwordButtons = [];
};

PasswordGenerator.prototype.generatePassword = function (event) {
  var button = $(event.target),
    input = $('.control #' + button.data('password-generator'));

  input.val(PasswordGenerator.prototype.randomPassword());
};

PasswordGenerator.prototype.randomPassword = function () {
  var validChars =
      '0123456789abcdefghijklmnopqrstuvwxyz!@#$%^&*()ABCDEFGHIJKLMNOPQRSTUVWXYZ_-',
    password = '',
    buf = new Uint8Array(24);

  window.crypto.getRandomValues(buf);
  for (var i = 0; i < buf.byteLength; ++i) {
    password += validChars[buf[i] % validChars.length];
  }

  return password;
};

module.exports = PasswordGenerator;
